import apiClient from './client';
import type {
  DashboardActiveCohort,
  DashboardUpcomingSession,
  DashboardAttentionSection,
  DashboardCohortCoachGroup,
} from '../../types';

export const dashboardApi = {
  getActiveCohorts: async (): Promise<DashboardActiveCohort[]> => {
    return apiClient.get<DashboardActiveCohort[]>('/api/dashboard/active-cohorts');
  },

  getUpcomingSessions: async (): Promise<DashboardUpcomingSession[]> => {
    return apiClient.get<DashboardUpcomingSession[]>('/api/dashboard/upcoming-sessions');
  },

  getAttentionItems: async (): Promise<DashboardAttentionSection> => {
    return apiClient.get<DashboardAttentionSection>('/api/dashboard/attention-items');
  },

  getCoachesAwaitingContracts: async (): Promise<DashboardCohortCoachGroup[]> => {
    return apiClient.get<DashboardCohortCoachGroup[]>('/api/dashboard/coaches-awaiting-contracts');
  },
};

export default dashboardApi;
